import React, { useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Stack,
} from '@mui/material';

function Menus({
  menu, options, onChange,
}) {
  useEffect(() => {
    if (options.length === 0) {
      onChange(null);
      return;
    }
    if (menu && options.some((m) => m.id === menu.id)) {
      return;
    }
    onChange(
      options.find(
        (option) => option.isServing,
      ) ||
      options[0],
    );
  }, [options, menu, onChange]);

  if (options.length < 2) {
    return null;
  }

  return (
    <Stack alignItems={{
      xs: 'center',
      md: 'start',
    }}
    >
      <FormControl
        sx={{
          width: {
            xs: '100%',
            md: 'unset',
          },
        }}
        variant="filled"
      >
        <InputLabel id="app-select-menu-label">Select a menu</InputLabel>
        <Select
          key={menu?.id} // force render when menu changes
          labelId="app-select-menu-label"
          id="app-select-menu"
          value={menu?.id}
          label="Select a menu"
          onChange={({ target: { value: id } }) => {
            onChange(options.find((m) => m.id === +id));
          }}
        >
          {options.map((m) => (
            <MenuItem
              value={m.id}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <Typography>{m.name}</Typography>
              <Typography variant="caption">{m.activeTime}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>

  );
}

export default Menus;
